import { rootRouteWithContext } from "@tanstack/react-router";
import { z } from "zod";
import { getInitialLocale } from "../utils/translation";
import { getWhiteLabel } from "../utils/white-label";
import type { QueryClient } from "@tanstack/react-query";

const searchParamsSchema = z.object({
  locale: z.string().optional(),
  currency: z.string().optional(),
});

export const rootRoute = rootRouteWithContext<{
  queryClient: QueryClient;
}>()({
  validateSearch: (search) => {
    const { locale, currency } = searchParamsSchema.parse(search);
    const wl = getWhiteLabel();

    return {
      locale: locale ?? getInitialLocale(),
      currency: currency ?? wl.currency ?? "USD", // TODO: get currency by IP
    };
  },
});
